import React from "react";
import { CustomerReviews } from "./reviewModels";
interface ReviewStarBreakdownProps {
  reviews: CustomerReviews;
  isProductReviewPage?: boolean;
}
interface RatingCounts {
  reviewCount: number;
  rating: number;
}
const ReviewsStarBreakdown = ({
  reviews,
  isProductReviewPage
}: ReviewStarBreakdownProps) => {
  const ratingCounts = (() => {
    const counts: RatingCounts[] = [];
    for (let starRating = 5; starRating > 0; starRating -= 1) {
      counts.push({
        rating: starRating,
        reviewCount: reviews.productReviewDetails.filter(review => review.oneToFiveStarRating === starRating).length
      });
    }
    return counts;
  })();
  const getRatingReviewCount = (reviewCount: number) => {
    return reviewCount / reviews.productReviewDetails.filter(review => review.oneToFiveStarRating > 0).length * 100;
  };
  return <div className={`review-star-breakdown ${isProductReviewPage ? "w-1/2 border-t-0 lt:flex lt:justify-center lt:items-center lt:py-6 lt:border-r px-5 xs:px-6 lt:px-8" : "xxxl:border-r pl-6 pr-5 sm:pr-2.5 xxxl:pl-8 xxxl:pr-4-1/2"} py-0 border-gray-200 xs:border-0 xs:border-l xs:border-solid ${!reviews.summary ? "xxxl:w-1/3" : "xxxl:w-[30%]"}`} data-sentry-component="ReviewsStarBreakdown" data-sentry-source-file="ReviewsStarBreakdown.tsx">
      <div className={`${isProductReviewPage ? "py-4 xs:py-4" : "py-6 xxxl:py-0"} w-full flex flex-col`}>
        {ratingCounts.map(ratingCount => <div className="w-full flex items-center pb-2.5 last:pb-0" key={ratingCount.rating}>
            <p className="sr-only">{`${ratingCount.reviewCount} reviews rated this ${ratingCount.rating} out of 5 stars.`}</p>
            <ul aria-hidden="true" className="rating w-auto flex items-center pr-2">
              <li className={`text-sm leading-none text-black pr-1 ${ratingCount.rating === 1 && "w-2 text-center"}`}>
                {ratingCount.rating}
              </li>
              <li className="icon-star" />
            </ul>
            <div aria-hidden="true" className="w-full flex items-center">
              <div className="progress-bar-border-fix h-2.5 mr-2 w-[calc(100%-40px)]" data-testid={`rating-progress-${ratingCount.rating}`} data-progress-percent={getRatingReviewCount(ratingCount.reviewCount)}>
                <span className={`block h-full relative overflow-hidden bg-green-500 rounded-tl-xl rounded-bl-[14px] ${ratingCount.reviewCount > 0 ? "pl-1" : "pl-0"} ${getRatingReviewCount(ratingCount.reviewCount) === 100 ? "rounded-tr-xl rounded-br-[14px]" : ""}`} style={{
              width: `${getRatingReviewCount(ratingCount.reviewCount)}%`
            }} />
              </div>
              <span className="text-sm leading-none text-gray-800">
                {ratingCount.reviewCount}
              </span>
            </div>
          </div>)}
      </div>
    </div>;
};
export default ReviewsStarBreakdown;